import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { User } from '../models/user';
import { publicRoutes } from '../routes/public-routes-list';
import { generalRoutes } from '../routes/general-routes-list';
import { activePermissionLevel } from '../utils/permission-level';

@Injectable({
  providedIn: 'root',
})
export class AffiliationGuardService {
  public generalRoutes = generalRoutes;
  public publicRoutes = publicRoutes;

  constructor(private router: Router) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (localStorage.getItem('access_token') && localStorage.getItem('user')) {
      let user = new User(JSON.parse(localStorage.getItem('user')!));
      if (user.affiliation == 'GENERAL') {
        const hasPermission = (key: string) => activePermissionLevel(user.permission_users, key) >= 1;

        // Land each user on their PRIMARY module — operators get NO ops dashboard.
        // Priority: ops dashboard > finance > PE > check-in/truck > container >
        // warehouse; final fallback is the user's own Profile (every user has it),
        // so a user with no module permission never lands on a blank/forbidden page.
        let target = this.generalRoutes.profile.profile.profile;
        if (hasPermission('DASHBOARD')) {
          target = this.generalRoutes.dashboard.index;
        } else if (hasPermission('FINANCE')) {
          target = this.generalRoutes.finance.dashboard;
        } else if (hasPermission('PHYSICAL_EXAMINATION')) {
          // PE before CHECK_IN: PE officers hold truck-view (CHECK_IN 1) too, but their
          // home is the PE module, so PE wins.
          target = this.generalRoutes.physicalExaminations.peTransactions.index;
        } else if (hasPermission('CHECK_IN')) {
          target = this.generalRoutes.truckManagement.gateTransactions.index;
        } else if (hasPermission('CONTAINER_TRANSACTION')) {
          target = this.generalRoutes.containerManagement.containerTransactions.index;
        } else if (
          hasPermission('WAREHOUSE_TRANSACTION') ||
          hasPermission('INTERNAL_WAREHOUSE_TRANSACTION')
        ) {
          target = this.generalRoutes.warehouseTransactions.warehouses.dashboard;
        }

        this.router.navigateByUrl(target);
        return true;
      }
    }
    localStorage.removeItem('access_token');
    this.router.navigateByUrl(this.publicRoutes.authentication.login);
    return false;
  }
}
